import { LocalStorage } from 'quasar';

export function setPage({ commit }, value) {
  commit('setPage', value);
}

export function setAnswer({ commit }, payload) {
  commit('setAnswer', payload);
}
export function setAnswerMulti({ commit }, payload) {
  commit('setAnswerMulti', payload);
}

export function getQuestions({ commit }) {
  const questions = LocalStorage.getItem('questions');
  if (questions) {
    commit('setQuestions', questions);
  }
}

export function saveQuestions({ state }) {
  LocalStorage.set('questions', state.questions);
}
